import { AnimatePresence, motion } from 'motion/react';

import { useCarousel } from './hooks/useCarousel';
import { useGetParams } from './hooks/useGetParams';
import { useVote } from './hooks/useVote';
// import { useMediaLoader } from './hooks/useMediaLoader';

import Advt from './components/Advt/Advt';
import { Question } from './components/Question/Question';
import { MessagesList } from './components/MessagesList/MessagesList';
// import { ResultQuiz } from './components/ResultQuiz/ResultQuiz';

import bgDefaultVideo from './assets/video/bgVideo.webm';
import posterDefault from './assets/images/bgPoster.png';
import logo from './assets/images/logo.png';

function App() {
  const { voteState, currentState } = useVote();
  const { showedMessages, messagesRef, winnerMessage, speed } = useCarousel();

  const { bgVideo, bgPoster, authorFontSize } = useGetParams();

  // const srcVideo = useMemo(() => {
  //   let correctVar = voteState?.vars?.find((el) => el.correct);
  //   if (correctVar) {
  //     let keyWords = JSON.parse(correctVar?.name || {}) || [];
  //     let numberPlayer = keyWords.find((word) => {
  //       const num = Number(word);
  //       if (!isNaN(num) && word !== '') {
  //         return num;
  //       } else return false;
  //     });

  //     const protocol = window?.location.protocol || 'https:';
  //     return numberPlayer
  //       ? `${protocol}//stream-test.iactive.pro/sibir-hk/videos/${numberPlayer}.mp4`
  //       : numberPlayer;
  //   } else return false;
  // }, [voteState?.vars]);

  // контроль загрузки медиа
  // const { isFullyLoaded } = useMediaLoader(srcVideo, 'video');

  return (
    <div className="app-wrapper" style={{ '--speed': `${speed}ms` }}>
      <AnimatePresence>
        {['S1', 'S2'].includes(currentState) && (
          <motion.div
            transition={{ duration: 0.5, delay: 0 }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="logoBlock"
            key="logoBlock"
          >
            <img src={logo} alt="" />
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <motion.div
            key={`${currentState}-question`}
            className="question"
            initial={{
              transform:
                'perspective(156rem) rotateX(12deg) rotateY(20deg) rotateZ(-2deg)',
            }}
            animate={{
              transform:
                'perspective(156rem) rotateX(12deg) rotateY(-10deg) rotateZ(1deg)',
              transition: {
                duration: 2,
                repeat: Infinity,
                repeatType: 'reverse',
              },
            }}
            exit={{
              transform: 'translateY(100vh)',
              transition: {
                duration: 0.5,
              },
            }}
          >
            <Question title={voteState?.title} />
          </motion.div>
        )}
        {currentState === 'S2' && (
          <motion.div
            key="advt"
            exit={{ y: '100vh' }}
            transition={{ duration: 0.5 }}
          >
            <Advt />
          </motion.div>
        )}

        {/* {currentState === 'S3' && isFullyLoaded && (
          <ResultQuiz key={srcVideo} playerSrc={srcVideo} />
        )} */}

        {['S4', 'S5', 'S6', 'S7'].includes(currentState) && (
          <MessagesList
            key="msgList"
            winId={winnerMessage?.message.id}
            messages={showedMessages}
            authorFontSize={authorFontSize}
            currentState={currentState}
            speed={speed || 0}
            messagesRef={messagesRef}
          />
        )}
      </AnimatePresence>

      {bgVideo && (
        <video
          autoPlay="autoplay"
          muted="muted"
          loop
          playsInline
          poster={bgVideo === '1' ? posterDefault : bgPoster}
          id="bgVideo"
        >
          <source
            src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
            type="video/webm"
          ></source>
        </video>
      )}
      <div id="img-loader" />
    </div>
  );
}

export default App;
